$(document).on('scroll', function() {
    if($(this).scrollTop()>240){
        $('.b-btn-up').show();
    } else {
        $('.b-btn-up').hide();
    }

    $('.js-btn-up').on('click', function() {
    	window.scrollTo(0, 0);
    });
})



// WEBPACK FOOTER //
// ./src/js/general/btn-up.js